import dynamic from "next/dynamic";
import React, { useState, useEffect, useMemo, useRef } from "react";

// const UniditEditor = React.lazy(() => {
//   return import("unidit-react");
// });
const importUnidit = () => import("@techzolab/zodit-react");

const UniditEditor = dynamic(importUnidit, {
  ssr: false,
});

const buttons = [
  "undo",
  "redo",
  "|",
  "bold",
  "strikethrough",
  "underline",
  "italic",
  "|",
  "superscript",
  "subscript",
  "|",
  "align",
  "|",
  "ul",
  "ol",
  //   "outdent",
  //   "indent",
  "justify",
  "|",
  "font",
  "fontsize",
  "brush",
  "paragraph",
  "|",
  "image",
  "link",
  "table",
  "|",
  "hr",
  "eraser",
  "copyformat",
  "|",
  "fullsize",
  "selectall",
  "print",
  "|",
  "source",
  "|",
];

const editorConfig = {
  readonly: false,
  toolbar: true,
  spellcheck: true,
  language: "en",
  toolbarButtonSize: "medium",
  toolbarAdaptive: false,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,
  askBeforePasteHTML: true,
  askBeforePasteFromWord: true,
  // defaultActionOnPaste: "insert_clear_html",
  buttons: buttons,
  uploader: {
    insertImageAsBase64URI: true,
  },
};

export const UniEditor = ({
  name,
  contents,
  onChange,
  height = 100,
  width = "100%",
  size = false,
  placeholder,
}) => {
  const editor = useRef(null);
  useEffect(() => {
    setValue(contents || ``);
  }, [contents]);

  editorConfig.width = width;
  editorConfig.height = height;

  const initialContent = contents ?? ``;
  const [value, setValue] = useState(initialContent);
  const isSSR = typeof window === "undefined";
  const target_name = name || "description";
  const [srcImage, setSrc] = useState(null);

  return (
    <>
      {!isSSR && (
        <React.Suspense fallback={<div>Loading RTE</div>}>
          <UniditEditor
            ref={editor}
            config={editorConfig}
            value={initialContent}
            onChange={(val) => {
              setValue(val);
              if (onChange) {
                const target = { name: target_name, value: val };
                onChange({ target });
              }
            }}
          />
        </React.Suspense>
      )}
    </>
  );
};
export default UniEditor;
